import { REAUTHENTICATE } from './auth-types';
import { authService } from '@dev.boon/brent';
import { store } from '../store';

export const reauthUser = async () => {
    try {
        const accessToken = authService.getAccessToken() || '';
        const refreshToken = authService.getRefreshToken() || '';

        // add checking to call reauth only if access token is present
        if (accessToken && refreshToken) {
            const result = await authService.reauthUser(accessToken, refreshToken);

            store().dispatch({
                type: REAUTHENTICATE,
                payload: {
                    token: result.accessToken,
                    user: result.user,
                },
            });

            return result;
        }

        return false;
    } catch (error) {
        // throw error to handle it on the component
        throw error;
    }
};
